import { forwardRef, useImperativeHandle, useRef } from 'react'
import { useNavigate } from 'react-router-dom'

import { Button, Link, NotificationDialog, Stack, Typography } from '../../../components'
import * as CreditCardGuest from '../../../components/payment/credit-card'
import { mutations } from '../../../graphql'
import { calculateGiftAmount } from '../gift-details-math'

export const PaymentUI = forwardRef(({ register }, ref) => {
  const cardApi = useRef()

  useImperativeHandle(ref, () => ({
    getPaymentMethodId: async (values) => {
      try {
        const isRecurring = values.stepperState?.giftDetails?.isRecurring
        const paymentMethodId = await cardApi.current.postToStripe({ ...values, multiUse: isRecurring || false })
        return paymentMethodId
      } catch (e) {
        throw new Error(`This guest card cannot be used to finalize the transaction: ${e.message || e.type}`)
      }
    },
  }))

  return (
    <Stack spacing={2}>
      <CreditCardGuest.GuestForm ref={cardApi} register={register} />
    </Stack>
  )
})

export async function getPaymentValues({ paymentMethodApi, values }) {
  const paymentMethodId = await paymentMethodApi.current.getPaymentMethodId(values)
  const { stepperState, ...other } = values
  return { ...other, paymentMethodId }
}

export function SuccessUI({ grantAmount, donationTargetName, donationTargetId }) {
  const navigate = useNavigate()

  const handleSignUpClick = () => {
    navigate('/sign-up')
  }

  return (
    <NotificationDialog
      open
      onClose={handleSignUpClick}
      type="success"
      title="Thank You for Your Generosity!"
      message={
        <>
          <Typography variant="body1" gutterBottom>
            Your donation of <strong>${grantAmount}</strong> to <strong>{donationTargetName}</strong> (
            <strong>{donationTargetId}</strong>) has been successfully processed. Together, we&apos;re making an impact,
            and we&apos;re so grateful for your support!
          </Typography>

          <Typography variant="h6" sx={{ mt: 2 }}>
            Here&apos;s what&apos;s next:
          </Typography>

          <Typography variant="body1" gutterBottom>
            To download your tax receipt and track your giving history, create a{' '}
            <Link to="/signup">GiveWise Giving Fund</Link>. It&apos;s quick, easy, and free!
          </Typography>

          <Typography variant="body1">With your GiveWise Giving Fund account, you can:</Typography>
          <ul>
            <li>
              <Typography variant="body1">Access all your tax receipts in one place.</Typography>
            </li>
            <li>
              <Typography variant="body1">Track your donations over time.</Typography>
            </li>
            <li>
              <Typography variant="body1">Set funds aside for future giving opportunities.</Typography>
            </li>
          </ul>
        </>
      }
      actions={[{ label: 'Create Your Giving Fund', onClick: handleSignUpClick }]}
    />
  )
}
